import { render, staticRenderFns } from "./LocalAuthLogin.vue?vue&type=template&id=604f5d09&scoped=true&"
import script from "./LocalAuthLogin.vue?vue&type=script&lang=js&"
export * from "./LocalAuthLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f5d09",
  null
  
)

export default component.exports